module.exports = __webpack_public_path__ + "assets/axios.752870cd.svg";